import { createFileRoute } from "@tanstack/react-router";
import { MonarchAlternativesComponent } from "@/pages/compare-monarch-alternatives";
import { head, loader } from "@/pages/compare-monarch-alternatives.meta";

export const Route = createFileRoute("/($locale)/compare/monarch-alternatives")({
  loader,
  head,
  component: function CompareMonarchAlternativesComponentRoute() {
    const { faqs, offersAsOf } = Route.useLoaderData();
    return <MonarchAlternativesComponent faqs={faqs} offersAsOf={offersAsOf} />;
  },
});
